import { throttle } from 'lodash-es';

const listeners: Array<() => void> = [];
const onUserActivity = throttle(
  () => {
    listeners.forEach(listener => listener());
  },
  10_000,
  { leading: true, trailing: true }
);

let initialized = false;
export function initializeActivityTracking() {
  if (initialized || typeof window === 'undefined') {
    return;
  }
  window.addEventListener('mousemove', onUserActivity, true);
  window.addEventListener('click', onUserActivity, true);
  window.addEventListener('keydown', onUserActivity, true);
  window.addEventListener('touchstart', onUserActivity, true);
  initialized = true;
}

export function subscribeToUserActivity(callback: () => void): () => void {
  initializeActivityTracking();

  listeners.unshift(callback);
  return () => {
    const index = listeners.indexOf(callback);
    if (index >= 0) {
      listeners.splice(index, 1);
    }
  };
}
